import { faqCusto, faqProgramar, faqSistema } from './shared'
import type { ProfessionPageConfig } from './types'

export const atendimento: ProfessionPageConfig = {
  path: '/ia-para-atendimento-ao-cliente/',
  key: 'atendimento',
  title: 'IA para atendente de SAC e suporte ao cliente | Oficina IA',
  description:
    'Três tarefas do atendimento que a IA adianta numa pasta: conversas do dia numa planilha, respostas prontas por dúvida e o relatório de motivos de contato.',
  imageAlt: 'Oficina IA: IA para atendimento ao cliente',
  whatsappMessage: 'Olá, Arthur. Vim pela página de IA para atendimento ao cliente e quero saber sobre o acompanhamento.',
  lastmod: '2026-09-25',
  heading: 'IA para atendimento ao cliente',
  intro:
    'Você ouve todo dia que "a IA vai atender". Aqui a IA fica do seu lado: três tarefas do atendimento que ela adianta no seu computador, sem programar, enquanto quem fala com o cliente continua sendo você.',
  rogerio: { pose: 'pedindo-esclarecimento', text: 'Quem atende é você. Eu só organizo a fila.' },
  tasks: [
    {
      title: 'As conversas do dia numa planilha',
      tone: 'sky',
      brings: 'as conversas exportadas ou copiadas do dia.',
      helps: 'monta a planilha: quem pediu o quê, o que ficou pendente.',
      continues: 'fecha os pendentes primeiro.',
    },
    {
      title: 'Respostas prontas por tipo de dúvida',
      tone: 'peach',
      brings: 'um punhado de atendimentos que deram certo.',
      helps: 'separa por tipo de dúvida e escreve uma resposta base para cada um, no seu tom.',
      continues: 'ajusta e usa quando a dúvida repetir.',
    },
    {
      title: 'Relatório de motivos de contato',
      tone: 'sage',
      brings: 'a planilha da semana.',
      helps: 'conta os motivos e escreve o resumo para o chefe.',
      continues: 'aponta onde dói e o que mudar.',
    },
  ],
  steps: {
    do: 'A IA monta a planilha, as respostas base ou o relatório dentro da sua pasta.',
    check: 'Leia cada resposta antes de usar com um cliente. A IA pode se enganar; a voz da empresa é sua.',
    resume: 'No dia seguinte, troque as conversas e repita o pedido.',
  },
  faq: [
    faqProgramar,
    {
      question: 'A IA vai me substituir?',
      answer: 'Isso quem decide é a sua empresa. O que esta página mostra é como usar a ferramenta a seu favor no trabalho que você já faz, e isso conta quando a decisão chegar.',
    },
    faqSistema('sistema de atendimento'),
    faqCusto,
  ],
  closing: {
    title: 'Sua primeira fila organizada, com alguém do lado.',
    text: 'Traga as conversas de um dia ou as respostas que você repete.',
    rogerio: 'Eu cuido do novelo. Você cuida do cliente.',
  },
}
